<mat-toolbar>
  <button mat-icon-button (click)="sidenav.toggle()" class="menu-toggler" *ngIf="app.isAuthenticated && routerService.isAuthRoute()" matTooltip="Toggle showing the side menu">
    <mat-icon>menu</mat-icon>
  </button>

  <button mat-button style="color: #fff !important;" id="account-name" #accountSwitcherButton (click)="onOpenAccountSwitcher(accountSwitcherButton)" matTooltip="Open the account switcher." *ngIf="app.isAuthenticated">
    {{ getAccountName() }}
    <mat-icon>arrow_drop_down</mat-icon>
  </button>

  <ng-container *ngIf="app.isAuthenticated && app.user.is_sitesoft_admin && app.quickAccessSession">
    <mat-menu #quickAccessMenu="matMenu">
      <button mat-menu-item (click)="onResetQuickAccessTimers()">
        <mat-icon>refresh</mat-icon>
        <span>Reset Timers</span>
      </button>
      <button mat-menu-item (click)="onDetachQuickAccess()">
        <mat-icon>link_off</mat-icon>
        <span>Detach Timers</span>
      </button>
    </mat-menu>
    <button mat-button
            [matMenuTriggerFor]="quickAccessMenu"
            class="quick-access-indicator"
            [class.warning]="isQuickAccessWarning">
      <mat-icon>timer</mat-icon>
      Inactivity: {{ inactivityTimeRemaining }} | Max: {{ hardCapTimeRemaining }}
    </button>
  </ng-container>

  <span style="flex: 1 1 auto;"></span>

  <ng-container *ngIf="app.isAuthenticated && (backgroundExports.activeCount$ | async) as exportCount">
    <button
      mat-button
      [matMenuTriggerFor]="backgroundExportsMenu"
      class="background-exports-indicator"
      style="color: #fff !important;"
      [matTooltip]="exportCount === 1
        ? 'An export is being prepared. Click to manage.'
        : exportCount + ' exports are being prepared. Click to manage.'"
      aria-label="Background exports in progress">
      <mat-icon class="background-exports-indicator-icon" [matBadge]="exportCount.toString()" matBadgeColor="accent" matBadgeSize="small" aria-hidden="true">cloud_download</mat-icon>
    </button>

    <mat-menu #backgroundExportsMenu="matMenu">
      <div class="px-3 py-2 text-muted" style="font-size: 12px; max-width: 260px; white-space: normal;">
        {{ exportCount === 1 ? '1 export is being prepared.' : exportCount + ' exports are being prepared.' }}
        You will be notified by email when each one is ready. The files will also appear on the My Exports page (Coming Soon).
      </div>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="onCancelAllBackgroundExports()" matTooltip="Stop polling for every in-flight export. The exports will still complete on the server.">
        <mat-icon>cancel</mat-icon>
        <span>Stop Polling for All Exports</span>
      </button>
    </mat-menu>
  </ng-container>

  <ng-container *ngIf="!mobileQuery.matches && utils.getUpvotyLink()">
    <a [href]="utils.getUpvotyLink()" target="_blank" mat-button style="color: #fff !important;" matTooltip="Open the community-driven roadmap to report:&#13;- Feature Requests&#13;- Performance Issues&#13;">
      <mat-icon>timeline</mat-icon>
      Roadmap
    </a>
  </ng-container>

  <ng-container *ngIf="!mobileQuery.matches">
    <a [href]="utils.getKnowledgebaseUrl()" target="_blank" mat-button style="color: #fff !important;" matTooltip="Open the user guide to learn more.">
      <mat-icon>library_books</mat-icon>
      User Guide
    </a>
  </ng-container>

  <span appMarginLeft *ngIf="!mobileQuery.matches">{{ utils.getEnvModeAsText() }}</span>
  <span appMarginLeft>{{ utils.getAppVersion() }}</span>

  <button mat-icon-button [matMenuTriggerFor]="adminMenu" *ngIf="app.isAuthenticated && app.user.is_sitesoft_admin" matTooltip="System Administrators Menu">
    <mat-icon>apps</mat-icon>
  </button>

  <mat-menu #adminMenu="matMenu">
    <button mat-menu-item routerLink="/admin">
      <mat-icon>menu</mat-icon>
      <span>Admin</span>
    </button>

    <button mat-menu-item routerLink="/admin/accounts">
      <mat-icon>account_tree</mat-icon>
      <span>Accounts</span>
    </button>

    <button mat-menu-item routerLink="/admin/sites">
      <mat-icon>poll</mat-icon>
      <span>All {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}</span>
    </button>

    <button mat-menu-item routerLink="/admin/users">
      <mat-icon>people</mat-icon>
      <span>Users</span>
    </button>

    <button mat-menu-item routerLink="/admin/codes">
      <mat-icon>qr_code</mat-icon>
      <span>QR Codes</span>
    </button>

    <button mat-menu-item routerLink="/items">
      <mat-icon>assignment</mat-icon>
      <span>Pre-Qualification Items</span>
    </button>

    <button mat-menu-item routerLink="/gitlab-issues">
      <mat-icon>construction</mat-icon>
      <span>Development Schedule</span>
    </button>

    <button mat-menu-item routerLink="/admin/trades">
      <mat-icon>work</mat-icon>
      <span>Job Titles</span>
    </button>

    <button mat-menu-item routerLink="/admin/industries">
      <mat-icon> business</mat-icon>
      <span>Industries</span>
    </button>

    <button mat-menu-item routerLink="/admin/ppe">
      <mat-icon>headset</mat-icon>
      <span>PPE</span>
    </button>

    <button mat-menu-item routerLink="/admin/work-permits">
      <mat-icon>assignment_ind</mat-icon>
      <span>Work Permits</span>
    </button>

    <button mat-menu-item routerLink="/admin/task-analyses-revised">
      <mat-icon>developer_board</mat-icon>
      <span>{{ utils.getLangTerm('ta-jsa-swms.singular', 'TA/JSA/SWMS') }} Templates</span>
    </button>

    <button mat-menu-item routerLink="/admin/system-notifications">
      <mat-icon>notifications_active</mat-icon>
      <span>System Notifications</span>
    </button>

    <button mat-menu-item routerLink="/system-banners">
      <mat-icon>campaign</mat-icon>
      <span>System Banners</span>
    </button>

    <button mat-menu-item routerLink="/admin/configuration">
      <mat-icon>build</mat-icon>
      <span>Configuration</span>
    </button>

    <button mat-menu-item (click)="onSentryErrorTester()" *ngIf="!this.utils.isProduction()" matTooltip="Test that Sentry is working by simulating an error.">
      <mat-icon>error</mat-icon>
      <span>Error Tester</span>
    </button>
  </mat-menu>

  <button mat-icon-button (click)="onOpenChat()" *ngIf="hubspot.isEnabled()" [matTooltip]="chatOpening ? 'Opening chat...' : 'Chat with us'">
    <mat-icon *ngIf="!chatOpening">support_agent</mat-icon>
    <mat-icon *ngIf="chatOpening" class="hs-chat-spin">autorenew</mat-icon>
  </button>

  <button mat-icon-button [matMenuTriggerFor]="helpMenu" matTooltip="Help">
    <mat-icon>help</mat-icon>
  </button>

  <mat-menu #helpMenu="matMenu">
    <ng-container *ngIf="mobileQuery.matches && utils.getUpvotyLink()">
      <a [href]="utils.getUpvotyLink()" target="_blank" style="text-decoration: none; color: inherit;" mat-menu-item matTooltip="Open the community-driven roadmap to report:&#13;- Feature Requests&#13;- Performance Issues&#13;">
        <mat-icon>timeline</mat-icon>
        Roadmap
      </a>
    </ng-container>

    <ng-container *ngIf="mobileQuery.matches">
      <a [href]="utils.getKnowledgebaseUrl()" target="_blank" style="text-decoration: none; color: inherit;" mat-menu-item matTooltip="Open the user guide to learn more.">
        <mat-icon>library_books</mat-icon>
        User Guide
      </a>
    </ng-container>

    <a [href]="utils.getReleaseNotesUrl()" target="_blank" style="text-decoration: none; color: inherit;" mat-menu-item matTooltip="Open the release notes for the software.">
      <mat-icon>notes</mat-icon>
      Release Notes
    </a>

    <button mat-menu-item routerLink="/contact-us">
      <mat-icon>email</mat-icon>
      <span>Contact Us</span>
    </button>
  </mat-menu>

  <!--
    Trigger and menu wrapped together on purpose. Angular Material renders mat-menu content into a CDK
    overlay, so a menu declared outside its trigger's guard stays in the DOM even when the trigger is
    hidden. Only one trigger exists and menuCan.settings hides it, so this was not reachable, but the
    convention is there to stop the next edit making it reachable.
  -->
  <ng-container *ngIf="app.isAuthenticated && menuCan.settings">
  <button mat-icon-button [matMenuTriggerFor]="settingsMenu" matTooltip="Configure your Company information">
    <mat-icon>settings</mat-icon>
  </button>

  <mat-menu #settingsMenu="matMenu">

    <ng-container *ngIf="app.isAuthenticated && menuCan.companyDetails">
      <button mat-menu-item routerLink="/account/details">
        <mat-icon>business</mat-icon>
        <span>Company Details</span>
      </button>

      <button mat-menu-item routerLink="/account/settings">
        <mat-icon>settings</mat-icon>
        <span>Settings</span>
      </button>
    </ng-container>

    <button *ngIf="app.isAuthenticated && menuCan.companyDocuments" mat-menu-item routerLink="/account/folders">
      <mat-icon>folder</mat-icon>
      <span>Company Documents</span>
    </button>

    <button *ngIf="app.isAuthenticated && menuCan.rbacRoles" mat-menu-item routerLink="/account/rbac-roles">
      <mat-icon>lock</mat-icon>
      <span>RBAC Roles</span>
    </button>

    <button *ngIf="app.isAuthenticated && menuCan.notificationRoles" mat-menu-item routerLink="/account/notification-roles">
      <mat-icon>notifications_active</mat-icon>
      <span>Notification Roles</span>
    </button>

    <button *ngIf="app.isAuthenticated && menuCan.tags" mat-menu-item routerLink="/account/tags">
      <mat-icon> local_offer</mat-icon>
      <span>Manage Tags</span>
    </button>
  </mat-menu>
  </ng-container>

  <button mat-icon-button [matMenuTriggerFor]="accountMenu" *ngIf="app.isAuthenticated" matTooltip="Configure your User information">
    <mat-icon [matBadge]="userMessagesService.unread_messages_count.toString()" matBadgePosition="above">account_circle</mat-icon>
  </button>

  <mat-menu #accountMenu="matMenu">
    <ng-container *ngIf="menuCan.userProfile">
      <button mat-menu-item routerLink="/user/details">
        <mat-icon>account_box</mat-icon>
        <span>{{ app.user.contact_person }}</span>
      </button>

      <button mat-menu-item routerLink="/user/multi-account-dashboard">
        <mat-icon>dashboard</mat-icon>
        <span>Multi-Account Dashboard</span>
      </button>

      <button mat-menu-item routerLink="/user/messages">
        <mat-icon [matBadge]="userMessagesService.unread_messages_count.toString()" matBadgePosition="above">message</mat-icon>
        <span>My Messages</span>
      </button>

      <button mat-menu-item routerLink="/user/tasks">
        <mat-icon>list</mat-icon>
        <span>My Tasks</span>
      </button>

      <button mat-menu-item routerLink="/user/dynamic-forms">
        <mat-icon>assignment</mat-icon>
        <span>My Forms</span>
      </button>

      <button mat-menu-item routerLink="/account/user/folders">
        <mat-icon>assignment</mat-icon>
        <span>Training/Competency</span>
      </button>

      <!-- Coming Soon -->
      <!--button mat-menu-item routerLink="/user/background-exports">
        <mat-icon>cloud_download</mat-icon>
        <span>My Exports</span>
      </button-->

      <!--
        The only route back to the membership status page once the user navigates away from it (SC-301).
        The shell banner covers a PENDING request, but a DECLINED one shows no banner, so without this a
        user who was refused had no way to read the reason, request again, or pick a different employer.

        Shown only while a request is outstanding or refused, so it does not clutter the menu for the
        majority who have neither. Badged when refused, because that is the state needing action.
      -->
      @if(hasOwnAccessRequest) {
        <button mat-menu-item routerLink="/user/account-access">
          <mat-icon matBadge="!" matBadgeColor="warn" matBadgePosition="above"
                    [matBadgeHidden]="!hasDeclinedAccessRequest">business</mat-icon>
          <span>Account Access</span>
        </button>
      }

      <button mat-menu-item routerLink="/login-credentials">
        <mat-icon>lock</mat-icon>
        <span>Change Login Credentials</span>
      </button>

      <button mat-menu-item routerLink="/user/api-tokens">
        <mat-icon>vpn_key</mat-icon>
        <span>API Tokens</span>
      </button>
    </ng-container>

    <button mat-menu-item (click)="onSignOut()">
      <mat-icon>exit_to_app</mat-icon>
      <span>Log out</span>
    </button>
  </mat-menu>

</mat-toolbar>
